import { render } from "./Cotizador.vue?vue&type=template&id=492ac2c8&scoped=true"
import script from "./Cotizador.vue?vue&type=script&lang=js"
export * from "./Cotizador.vue?vue&type=script&lang=js"

import "./Cotizador.vue?vue&type=style&index=0&id=492ac2c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-492ac2c8"]])

export default __exports__